module.exports = __webpack_public_path__ + "static/media/desktop.7e5d42bb.svg";